import React from "react";
import {GroupHighlightsPanel} from "../../../../../../components/SettingsPanel/subComponents";

export default ({ groupHighlights }) => {


	return <GroupHighlightsPanel groupHighlights={groupHighlights} />;
};
